import asyncSeries from 'async/series';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  createOrg,
};

let g_volumeList: any = null;

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done && done();
}

function createOrg(params: any, done: (err: any) => void) {
  const {
    org_name,
    filestore_username,
    filestore_password,
    filestore_tenant,
    filestore_container,
  } = params;

  let org1;
  asyncSeries(
    [
      (done) => {
        const opts = {
          url: '/api/1/org/1',
        };
        UserStore.get(opts, (err, body) => {
          if (err) {
            util.errorLog('OrgStore.createOrg: get err:', err);
          } else {
            org1 = body;
          }
          done(err);
        });
      },
      (done) => {
        const opts = {
          url: `/api/1/org`,
          body: {
            org_name,
            filestore_username,
            filestore_password,
            filestore_tenant,
            filestore_container,
            aws_access_key_id: org1.aws_access_key_id,
            aws_secret_access_key: org1.aws_secret_access_key,
            github_auth: org1.github_auth,
          },
        };
        UserStore.post(opts, (err, body) => {
          if (err) {
            util.errorLog('OrgStore.createOrg: post err:', err, body);
            done(err);
          } else {
            UserStore.verifySessionKey(() => done());
          }
        });
      },
    ],
    done
  );
}
